import { SITE_URL } from './comparePages';

const JSON_LD_ID = 'compopo-json-ld';

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

export function setPageMeta({
  title,
  description,
  canonical,
  ogImage = `${SITE_URL}/img/nucleo-logo.svg`,
  locale = 'he',
}) {
  if (title) {
    document.title = title;
  }
  upsertMeta('name', 'description', description);
  upsertMeta('property', 'og:title', title);
  upsertMeta('property', 'og:description', description);
  upsertMeta('property', 'og:url', canonical || SITE_URL);
  upsertMeta('property', 'og:type', 'website');
  upsertMeta('property', 'og:image', ogImage);
  upsertMeta('property', 'og:site_name', 'Compopo');
  upsertMeta('name', 'twitter:card', 'summary_large_image');
  upsertMeta('name', 'twitter:title', title);
  upsertMeta('name', 'twitter:description', description);
  upsertLink('canonical', canonical || SITE_URL);
  document.documentElement.lang = locale === 'he' ? 'he' : 'en';
}

export function injectJsonLd(schemaObject) {
  let el = document.getElementById(JSON_LD_ID);
  if (!el) {
    el = document.createElement('script');
    el.id = JSON_LD_ID;
    el.type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(schemaObject);
}

export function removeJsonLd() {
  const el = document.getElementById(JSON_LD_ID);
  if (el) {
    el.remove();
  }
}

export function buildComparePageSchema(page, locale, products = []) {
  const title = locale === 'he' ? page.titleHe : page.titleEn;
  const description = locale === 'he' ? page.descriptionHe : page.descriptionEn;
  const url = `${SITE_URL}/compare/${page.slug}`;

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: title,
    description,
    url,
    inLanguage: locale === 'he' ? 'he-IL' : 'en-US',
    isPartOf: {
      '@type': 'WebSite',
      name: 'Compopo',
      url: SITE_URL,
    },
  };

  if (products.length) {
    schema.mainEntity = {
      '@type': 'ItemList',
      numberOfItems: products.length,
      itemListElement: products.slice(0, 10).map((product, index) => {
        const store = product.otherStores && product.otherStores[0];
        return {
          '@type': 'ListItem',
          position: index + 1,
          item: {
            '@type': 'Product',
            name: store ? store.title : '',
            offers: store && store.price ? {
              '@type': 'Offer',
              price: store.price.calcTotalPrice,
              priceCurrency: store.price.calcCurrency || 'USD',
            } : undefined,
          },
        };
      }),
    };
  }

  return schema;
}

export function buildDefaultHomeMeta(locale) {
  const isHe = locale === 'he';
  return {
    title: isHe
      ? 'Compopo – השוואת מחירים ב-eBay, AliExpress ו-Amazon'
      : 'Compopo – Compare Prices on eBay, AliExpress & Amazon',
    description: isHe
      ? 'השוו מחירים מעל 10 חנויות בינלאומיות. מצאו את המחיר הזול ביותר כולל משלוח לישראל.'
      : 'Compare prices from 10+ international stores. Find the lowest price including shipping.',
    canonical: SITE_URL,
    locale,
  };
}
